<template>
  <div v-if="!isLoading" class="chart-scroll-container">
    <div class="chart-scroll-inner" :style="{ width: chartWidth + 'px' }">
      <apexchart
        type="line"
        height="400px"
        :width="'100%'"
        :options="chartOptions"
        :series="seriesChartDiaDia"
      ></apexchart>
    </div>
  </div>

  <div v-else>
    <div class="text-center">
      <b-spinner small label="Small Spinner" type="grow"></b-spinner>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { formatNumberToBRL } from '../../helpers/formaters'

export default {
  name: 'ChartDiaDia',

  components: {
    apexchart: VueApexCharts,
  },

  props: {},

  data() {
    return {
      minWidthPerPoint: 10,
      chartOptions: {
        chart: {
          type: 'line',
          stacked: true,
          stackType: 'normal',
          zoom: false,
          toolbar: { show: true, tools: { download: true } },
          animations: { enabled: false, easing: 'linear', speed: 0 },
        },
        plotOptions: { bar: { horizontal: false } },
        stroke: { curve: 'smooth', width: [0, 0, 3, 3] },
        markers: { size: 3, colors: ['#becf16', '#f9b11c', 'gray', '#22A06B'] },
        title: {
          /*text: "Flúxo de Caixa" */
        },
        colors: ['#becf16', '#f9b11c', 'gray', '#22A06B'],
        dataLabels: { enabled: false, enabledOnSeries: [1] },
        labels: [],
        xaxis: {
          type: 'category',
          labels: {
            formatter: (value) => this.formatterDatetime(value),
          },
        },
        yaxis: {
          labels: {
            formatter: (value) => this.formatterMoeda(value),
          },
        },
        tooltip: {
          y: {
            formatter: (value) => this.formatterMoeda(value),
          },
        },
      },
    }
  },

  computed: {
    ...mapGetters('financeiro', {
      isLoading: 'getIsLoading',
      inputTransactions: 'getInputTransactionsList',
      outputTransactions: 'getOutputTransactionsList',
      superArrayInputTransactions: 'getSuperArrayInputTransactions',
      superArrayOutputTransactions: 'getSuperArrayOutputTransactions',
    }),

    chartLabels() {
      return Object.keys(this.superArrayOutputTransactions).filter(
        (key) => key !== 'total'
      )
    },

    chartWidth() {
      const labelCount = this.chartLabels.length
      const containerWidth =
        typeof window !== 'undefined'
          ? Math.max(
              640,
              document.getElementById('chart-dia-dia-container')
                ? document.getElementById('chart-dia-dia-container')
                    .offsetWidth * 0.98
                : 0
            )
          : 800

      if (labelCount === 0) return containerWidth

      return Math.max(containerWidth, labelCount * this.minWidthPerPoint)
    },

    seriesChartDiaDia() {
      var chartLabels = this.chartLabels
      var outputSeries = []
      var inputSeries = []
      var avaregeSeries = []
      var accumulatedSeries = []
      var accumulatedTotal = 0

      chartLabels.forEach((label) => {
        if (label != 'total') {
          var totalIn =
            this.superArrayInputTransactions[label] &&
            this.superArrayInputTransactions[label].total != null
              ? Number(this.superArrayInputTransactions[label].total.toFixed(2))
              : 0
          inputSeries.push(totalIn)

          var totalOut =
            this.superArrayOutputTransactions[label] &&
            this.superArrayOutputTransactions[label].total != null
              ? Number(
                  this.superArrayOutputTransactions[label].total.toFixed(2)
                )
              : 0
          totalOut = totalOut * -1
          outputSeries.push(totalOut)

          const average = Number((totalIn + totalOut).toFixed(2))
          avaregeSeries.push(average)
          accumulatedTotal = Number((accumulatedTotal + average).toFixed(2))
          accumulatedSeries.push(accumulatedTotal)
        }
      })

      this.chartOptions.chart.animations.enabled = inputSeries.length < 60
      this.chartOptions.labels = chartLabels.map((date) =>
        moment(date).format('DD/MM/YY')
      )

      var series = [
        { name: 'Entradas', type: 'column', data: [] },
        { name: 'Saídas', type: 'column', data: [] },
        { name: 'Balanço do dia', type: 'line', data: [] },
        {
          name: 'Acumulado do período: ' + formatNumberToBRL(accumulatedTotal),
          type: 'point',
          data: [],
        },
      ]
      series[0].data = inputSeries
      series[1].data = outputSeries
      series[2].data = avaregeSeries
      // series[3].data = accumulatedSeries
      return series
    },
  },

  methods: {
    formatterMoeda(value) {
      const number = Number(value)
      if (isNaN(number)) return formatNumberToBRL(0)
      return formatNumberToBRL(Number(number.toFixed(2)))
    },

    formatterDatetime(value) {
      if (!value) return ''
      const parsed = moment(
        value,
        ['DD/MM/YY', 'YYYY-MM-DD', moment.ISO_8601],
        true
      )
      if (parsed.isValid()) return parsed.format('DD/MM/YY')
      return String(value)
    },

    updateLabels(labels) {
      this.chartOptions.labels = labels
    },
  },
}
</script>

<style scoped>
.chart-scroll-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.chart-scroll-inner {
  min-width: 100%;
}
</style>
